import { RouteProps } from "react-router-dom";
import Content from "Types/Content";
import styles from "./assets/styles.module.scss";
import profileImage from "./assets/profile-image.jpg";
import masterpiece from "./assets/Motionless-In-White-Masterpiece.jpg";
import portadaMotionless from "./assets/portada-motionless.jpg";
import portadaAvenged from "./assets/avenged-sevenfold.jpg";
import adInfinitum from "./assets/adInfinitum.jpg";
import apocaliptica from "./assets/apocaliptica.jpg";
import fallingInReverse from "./assets/fallingInReverse.png";
import threeDaysGrace from "./assets/threeDaysGrace.jpg";
import hollowKnight from "./assets/hollowKnight.jpg";
import godOfWarR from "./assets/godOfWarR.jpg";
import MediaLinkBox from "Componentes/MediaLinkBox";
import BandList from "Componentes/BandList";

const imagenesDeBandas = [
  portadaMotionless,
  portadaAvenged,
  adInfinitum,
  apocaliptica,
  fallingInReverse,
  threeDaysGrace
];

const LuiSanchez: React.FC<RouteProps> = () => {
  return (
    <div className='container'>
      <div className={` ${styles.profile}`}>
        <h2>¡Hola!, Soy Luis Sanchez</h2>
        <img src={profileImage} alt='profile-image' />
      </div>
      <hr />
      <p className={` ${styles.littleText}`}>
        Actualmente soy Trainee en Front-End/Back-End. <br />
        Disfruto a partes iguales de la programación, el desarrollo y el
        hardware. Tengo gusto por diversos estilos musicales, pero más por unos
        que por otros. <br />
        Mis pasatiempos son los videojuegos, las peliculas y las series; y tengo
        cierto gusto por la comedia también.
      </p>
      <hr />
      <h3 className={`${styles.h3}`}>Preferencias Musicales:</h3>
      <div className={`${styles.musica}`}>
        <div className={`${styles.tableContainer}`}>
          <MediaLinkBox
            image={masterpiece}
            url={"https://www.youtube.com/watch?v=rbFaVDfkI00"}
            title={"Recientemente Escuchada:"}
          />
          <BandList
            title={"Bandas más Escuchadas:"}
            images={imagenesDeBandas}
          />
        </div>
        <div className='glass'></div>
      </div>
      <h3 className={`${styles.h3}`}>Gaming:</h3>
      <div className={`${styles.gaming}`}>
        <div className={`${styles.tableContainer}`}>
          <MediaLinkBox
            image={godOfWarR}
            url={"https://www.youtube.com/watch?v=FLn_sEiKOjY"}
            title={"Videojuego Favorito (SAGA):"}
          />
          <MediaLinkBox
            image={hollowKnight}
            url={"https://www.youtube.com/watch?v=UAO2urG23S4"}
            title={"Mayor Desafío Superado:"}
          />
        </div>
      </div>
    </div>
  );
};

export default new Content({
  Component: LuiSanchez,
  title: "Luis Sanchez",
  route: "LuisSanchez",
  tags: [
    "Frontend",
    "Backend",
    "CSS",
    "HTML",
    "JavaScript",
    "Vue.js",
    "PHP",
    "Laravel"
  ]
});
